import { CellRendererParams, ColumnDef } from '../../models';
import { HealthStatus } from '../../../../health';
import { HealthIconCellRenderer } from '../../../../health/HealthIconCellRenderer';
import { DEFAULT_EMPTY_CELL_PLACEHOLDER } from '../../constants';

export const HealthCellRenderer = <TData, TValue>(props: CellRendererParams<TData, TValue>): JSX.Element => {
  const { getValue } = props;
  let value = getValue?.();
  const colDef = props.colDef as ColumnDef<TData, TValue>;
  let healthStatus = value != null ? (value as HealthStatus) : null;
  if (healthStatus == null) {
    healthStatus = HealthStatus.UNKNOWN;
  }

  return <HealthIconCellRenderer value={healthStatus} {...colDef?.cellTypeOptions} />;
};
